export type WorkspaceContext =
  | { kind: 'intelligence' }
  | { kind: 'agent'; agentId: string };

const WORKSPACE_CONTEXT_KEY = 'workspaceContext';

export function getPersistedWorkspaceContext(): WorkspaceContext {
  try {
    const raw = localStorage.getItem(WORKSPACE_CONTEXT_KEY);
    if (raw) return JSON.parse(raw) as WorkspaceContext;
  } catch {
    // fall through to default
  }
  return { kind: 'intelligence' };
}

export function persistWorkspaceContext(ctx: WorkspaceContext): void {
  try {
    localStorage.setItem(WORKSPACE_CONTEXT_KEY, JSON.stringify(ctx));
  } catch {
    // ignore
  }
}